import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import { rankingScale } from 'shared/constants/esg';
import { useReportPage } from 'shared/hooks';

const circleUseStyles = makeStyles(theme => ({
  item: {
    borderRadius: '50%',
    position: 'relative',
    width: 120,
    height: 120,
    transform: useReportPage ? 'scale(0.7)' : 'scale(1)',
    marginLeft: useReportPage ? -25 : 0,
    transition: 'background-color 200ms',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.custom.white,
      '& $divider': {
        backgroundColor: theme.palette.custom.white,
      },
    },
  },
  textWrapper: {
    margin: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 90,
    transform: 'translate(-50%, -50%)',
  },
  text: {
    textAlign: 'center',
    fontWeight: 500,
    lineHeight: '20px',
  },
  rankText: {
    textAlign: 'center',
    fontWeight: 500,
  },
  divider: {
    backgroundColor: theme.palette.custom.black,
    margin: theme.spacing(0.7, 0),
  },
}));

const CircleScale = ({ total, quarter, rank }) => {
  const { t } = useTranslation();
  const circleClasses = circleUseStyles();
  const quarterValue = Number(quarter) === 1 ? 'Top' : rankingScale[Number(quarter) - 1];

  return (
    <Paper className={circleClasses.item}>
      <div className={circleClasses.textWrapper}>
        <Typography variant="subtitle1" className={circleClasses.text}>
          {quarterValue}
        </Typography>
        <Typography variant="subtitle1" className={circleClasses.text}>
          {t('Quartile')}
        </Typography>
        <Divider className={circleClasses.divider} />
        <Typography variant="body2" className={circleClasses.rankText}>{`${t(
          'Rank',
        )} ${rank} of ${total}`}</Typography>
      </div>
    </Paper>
  );
};

CircleScale.propTypes = {
  total: PropTypes.number.isRequired,
  quarter: PropTypes.number.isRequired,
  rank: PropTypes.number.isRequired,
};

export { CircleScale };
